import { FC } from 'react'
import Swal from 'sweetalert2'
import {
  ModalSize,
  showAlertLoading,
  showConfirmAlert,
  showError,
} from '../../../../../../../_metronic/helpers'
import { invalidateToken, gerarToken } from '../../core/_requests'
import { getEmpresaById } from '../../../../empresa/empresas-list/core/_requests'
import { EmpresaList } from '../../../../empresa/empresas-list/core/_models'
import { RowActions, useModal, useToast } from '../../../../../../components'
import { TokenModal } from '../../component/modal/TokenModal'
import { WebHookModal } from '../../component/modal/WebHookModal'
import { useQueryResponse } from '../../core/QueryResponseProvider'

type Props = {
  empresa: EmpresaList
}

export const EmpresasActionsCell: FC<Props> = ({ empresa }) => {
  const { showModal } = useModal()
  const { showToast } = useToast()
  const { refetch } = useQueryResponse()
  const { id } = empresa
  const nome = empresa.nomeFantasia || empresa.nome || 'Instituição'

  const openTokenModal = () =>
    showModal({
      title: 'Token para API',
      content: <TokenModal />,
      size: ModalSize.Medium,
      fetchers: {
        accessToken: async () => {
          const { accessToken } = await gerarToken(id)
          return accessToken
        },
      },
    })

  const openWebhookModal = () =>
    showModal({
      title: 'Configurar WebHook',
      content: <WebHookModal />,
      size: ModalSize.Medium,
      fetchers: {
        empresa: () => getEmpresaById(id),
      },
    })

  // Invalidar derruba as integrações que usam o token atual: confirmação com a consequência.
  const askInvalidate = async () => {
    const confirmed = await showConfirmAlert({
      title: 'Invalidar token?',
      text: `As integrações de ${nome} que usam o token atual deixarão de funcionar até um novo token ser gerado.`,
      confirmButtonText: 'Invalidar token',
      cancelButtonText: 'Cancelar',
      danger: true,
    })
    if (!confirmed) return

    try {
      showAlertLoading()
      await invalidateToken(id)
      Swal.close()
      showToast({ variant: 'success', title: `Token de ${nome} invalidado.` })
      refetch()
    } catch (error) {
      showError(error)
    }
  }

  return (
    <RowActions
      itemName={nome}
      items={[
        { label: 'Gerar token', onClick: openTokenModal },
        { label: 'Configurar webhook', onClick: openWebhookModal },
        { label: 'Invalidar token', onClick: askInvalidate, danger: true, divider: true },
      ]}
    />
  )
}
